import actionTypes from 'store/actions'

const emptyState = {
  user: null,
  mobileVerivication: null,
  selectedBusiness: null,
  matched: 0,
  messages: [],
  kycUser: null,
  error: null,
  businessCategories: [],
}

const getIntialState = () => {
  if (!process.env['REACT_APP_ENV']) {
    try {
      const data = JSON.parse(localStorage.getItem('state') || '')
      return {
        ...data,
        user: {
          ...data.user,
          kycValidated: new Date(data.user.kycValidated),
          kybValidated: new Date(data.user.kybValidated),
          accessPeriodEnd: new Date(data.user.accessPeriodEnd),
          created_date: new Date(data.user.created_date),
        },
      }
    } catch (error) {
      return emptyState
    }
  }

  return emptyState
}

export const initialState = getIntialState()

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'userSignOut': {
      return { ...emptyState }
    }

    case 'userLoaded': {
      return {
        ...state,
        user: action.user,
      }
    }

    case 'userUpdated': {
      const nextUser = { ...state.user, ...action.user }

      return {
        ...state,
        user: nextUser,
      }
    }

    case 'claimedBusinessesLoaded': {
      if (state.selectedBusiness !== null) {
        const updatedBusiness = action.claimedBusinesses?.find(
          business => state.selectedBusiness && state.selectedBusiness.ext_id === business.ext_id,
        )
        if (updatedBusiness) {
          return {
            ...state,
            claimedBusinesses: action.claimedBusinesses || [],
            claimedBusinessesLoaded: true,
            selectedBusiness: updatedBusiness,
          }
        }
      }
      return {
        ...state,
        claimedBusinesses: action.claimedBusinesses || [],
        claimedBusinessesLoaded: true,
      }
    }

    case 'claimedBusinessUpdated': {
      const claimedBusinesses = state.claimedBusinesses
        ? [...state.claimedBusinesses, action.payload]
        : [action.payload]
      return {
        ...state,
        claimedBusinesses,
      }
    }

    case 'businessSelected': {
      return {
        ...state,
        selectedBusiness: action.business,
      }
    }

    case 'resetBusinessSelected': {
      return {
        ...state,
        selectedBusiness: null,
      }
    }

    case 'messagesLoaded': {
      return {
        ...state,
        messages: action.payload,
      }
    }

    case 'setError': {
      return {
        ...state,
        error: action.payload,
      }
    }

    case 'clearError': {
      return {
        ...state,
        error: null,
      }
    }

    case actionTypes.RESET_USER_STATE: {
      return emptyState
    }

    default:
      return state
  }
}

export default reducer
